// extracted by mini-css-extract-plugin
export var body = "_j1-8";
export var button = "_j1-0";
export var closeButton = "_j1-5";
export var content = "_j1-3";
export var empty = "_j1-f";
export var grid = "_j1-c";
export var header = "_j1-4";
export var icon = "_j1-1";
export var option = "_j1-d";
export var optionSelected = "_j1-e";
export var overlay = "_j1-2";
export var searchIcon = "_j1-a";
export var searchInput = "_j1-b";
export var searchWrapper = "_j1-9";
export var title = "_j1-6";
export var visuallyHidden = "_j1-7";